import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { InstructionService, AppService, DialogService, DroitsService, StateService, UtilitaryService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

const KEY = 'formulaire-dossier-dialog'

@Component({
  selector: 'atyl-formulaire-dossier-dialog',
  templateUrl: './formulaire-dossier-dialog.component.html',
  styleUrls: ['./formulaire-dossier-dialog.component.scss']
})
@Stringable({
  path: 'views/partials/layout/dialogs/formulaire-dossier-dialog',
  key: KEY,
})
export class FormulaireDossierDialogComponent extends BaseDialogComponent implements OnInit {
  @StringableValues(KEY)
  strings: any
  droits: any = [];
  forms: any[]
  formsFilters: any[];
  
  result: any = {
    id: '',
    selectedForm: {}
  };
  droitsObjets: any;
  selectedForm: boolean = false;
  
  search: any;
  
  constructor(
    public dialogRef: MatDialogRef<FormulaireDossierDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public utilities: UtilitaryService,
    private stateService: StateService,
    public droitsService: DroitsService,
    public instructionService:InstructionService,
    dialogService: DialogService,
    changeDetectorRef: ChangeDetectorRef,
   
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    this.droits = this.data.droits
    if(this.data.droitsObjets != undefined)
        this.droitsObjets = this.data.droitsObjets
    this.forms=[];
	this.formsFilters=[];
    this.instructionService.formulaires(this.data.instruction.ID).subscribe((res: JSONRpcResponse) => {
      this.forms = res.result
      for(let i=0;i<this.forms.length;i++) {
		 let f:any=this.forms[i];
		  if (f.key !=undefined && f.key
		  && this.droits[f.key]!=undefined
		  && this.droits[f.key].c!=undefined	
		  )
		    f.readAndAdd=this.droits[f.key].c;
          if(this.droitsObjets != undefined)
            f = this.setObjectUserRights(f,"formulaire");
		 
	  } 
      
	  this.formsFilters = [...this.forms];
	  
      console.log('FormulaireDossierDialogComponent',this.forms,this.droits);
      this.changeDetectorRef.detectChanges();
     })
    /*
    this.stateService.demandeType.subscribe((demandeTypes) => {
      this.forms = []
      console.log('init FormulaireDossierDialogComponent', demandeTypes)
      demandeTypes.forEach(element => {
        if (element.ID === this.data.instruction.demande.type.ID) {
          element.forms.forEach((form) => {
            if (this.data.typeForm && form.type === this.data.typeForm)
              this.forms.push(form)
            else if (!this.data.typeForm && (form.type === 0 || form.type === 3))
              this.forms.push(form)
            else if (!this.data.typeForm && form.type === 2)
              this.forms.push(form)
            else if (!this.data.typeForm && form.type === 5)
              this.forms.push(form)
          })
        }
      })
    })
    */


  }

  setSelectedForm() {
    this.selectedForm = false
    this.forms.forEach((form) => {
      if (form.selected)
        this.selectedForm = true
    })
  }

    setObjectUserRights(obj: any | any[], type: string) {
        if (Array.isArray(obj)) {
            obj.forEach((item: any) => {
                item = this.applyRightsObj(item, type);
            });
        } else {
            obj = this.applyRightsObj(obj, type);
        }
        return obj;
    }

    applyRightsObj(obj: any, type: string) {
        let rg: any = {
            r: true,
            w: true,
            x: true
        };
        let key = null;
        
        switch (type) {
            case "formulaire":
				if (obj.key!=undefined )
                	key = obj.key;
                break;
        }

        if (this.droitsObjets != undefined && this.droitsObjets[type] != undefined) {
            if (this.droitsObjets[type][key] != undefined) {
                rg = this.droitsObjets[type][key];
            }
        }

        obj.droitsObjets = rg;
        return obj;
    }
	
	filterResults() {
		    if (!this.search) {
		      this.formsFilters = [...this.forms];
		    } else {
		      this.formsFilters = [];
		      this.formsFilters = this.forms.filter((form) => {
		        return form.libelle.toUpperCase().indexOf(this.search.toUpperCase()) > -1;
		      });
		    }

	  	}
}
